<template>
  <v-container>
    <div class="my-div">
        <v-card>
            <v-toolbar flat>
                <v-toolbar-title> 會員登入</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="grey lighten-4 d-flex justify-center">
            <v-form v-model="valid" @submit.prevent="submit" style="width: 60%;">
                <v-row justify="center">
                    <v-col cols="12" md="12">
                        <v-text-field v-model="model.Account" :rules="[(v) => !!v || '必填項目']"
                            label="帳號" required></v-text-field>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="12">
                        <v-text-field v-model="model.Password" :rules="[(v) => !!v || '必填項目']"
                            label="密碼" :type="passwordType" required :append-icon="eyeIcon" @click:append="showPWD"></v-text-field>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="6">
                        <v-btn
                        class="white--text"
                        block
                        elevation="5"
                        color="blue-grey"
                        @click="setPwdDialog = true"
                        >
                        忘記密碼
                        </v-btn>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-btn
                        block
                        color="primary"
                        elevation="5"
                        type="submit"
                        >
                        登入
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
        </v-card>
    </div>
    <div class="my-div">
        <p class="text-left text-h5 font-weight-bold"><span style="color: #ff0000;"><strong><span
            style="font-size: 18pt;">■&nbsp;注意需知:</span></strong></span></p>
        <p>一、場地營運人員需完成個人資料帳號註冊成功，使用者才會接收到簡訊內容，請依照流程完成首次登入變更作業。</p>
        <p>二、個人密碼忘記時，請依照登入頁忘記密碼流程執行重設密碼<button class=guide style="color:#0032A0" @click="showGuide">(流程教學)</button></p>
        <!-- 引入Guide組件 忘記密碼流程說明 -->
        <guide ref="guide"></guide>
        <p>三、首次無法登入時請跟現場管理人員確定註冊的帳號是否正確。</p>
        <p>四、其它使用上如不清楚狀況，請洽各停車場營運管理人員協助指導。</p>
    </div>

    <v-dialog
      v-model="setPwdDialog" transition="dialog-bottom-transition" max-width="600px" persistent
    >
    <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>忘記密碼</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="cancelReSetPwd">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
            <v-stepper v-model="setPwdStep" class="mt-3">
                <!-- <v-stepper-header>
                    <v-stepper-step :complete="setPwdStep > 1" step="1">填寫帳號</v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step :complete="setPwdStep > 2" step="2">修改密碼</v-stepper-step>

                    <v-divider></v-divider>
                </v-stepper-header> -->
                <v-stepper-items>
                    <v-stepper-content step="1">
                    <v-form ref="verifyAccount" v-model="verifyAccount" @submit.prevent="submitReSetPwd(1)">
                        <v-row class="text-h6">
                            <v-col cols="12">簡訊取得驗證碼</v-col>
                        </v-row>
                        <v-row class="mt-2 mb-3" justify="center">
                            <v-col cols="12">
                                <v-text-field v-model="setPwdModel.Account" label="請輸入手機號碼" :rules="[(v) => !!v || '必填項目', (v) => taiwanMobileRegex.test(v) || '請輸入正確格式']"
                                required></v-text-field>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row justify="center">
                            <v-col cols="4" md="4">
                                <v-btn block class="mt-3 mb-1" type="button" @click="cancelReSetPwd">取消</v-btn>
                            </v-col>
                            <v-col cols="4" md="4">
                                <v-btn block color="primary" class="mt-3 mb-1" type="submit">下一步</v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                    </v-stepper-content>
                    <v-stepper-content step="2">
                        <v-row class="mb-3 text-h6">
                            <v-col cols="12">已發送至: {{ setPwdModel.Account }} 。請輸入收到的驗證碼</v-col>
                        </v-row>
                        <v-otp-input
                            class="mb-3"
                            ref="otpInput"
                            v-model="otp"
                            type="number"
                            @finish="onOTPFinish"
                        ></v-otp-input>
                        <v-divider></v-divider>
                        <v-row justify="center">
                            <v-col cols="4" md="4">
                                <v-btn block class="mt-3 mb-1" type="button" @click="backStep">上一步</v-btn>
                            </v-col>
                            <!-- <v-col cols="4" md="4">
                                <v-btn block color="primary" class="mt-3 mb-1" type="button" @click="onOTPFinish(otp)">下一步</v-btn>
                            </v-col> -->
                        </v-row>
                    </v-stepper-content>
                    <v-stepper-content step="3">
                    <v-form ref="verifyNewPwd" v-model="verifyNewPwd" @submit.prevent="submitReSetPwd(3)">
                        <v-row class="d-flex d-sm-none mt-3 text-h6">
                            <v-col cols="12">請輸入以下資訊</v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field v-model="setPwdModel.Password" :rules="[(v) => !!v || '必填項目', (v) => (v || '').length >= 8 || '最少長度為8碼']"
                                    label="新密碼" :type="newPwdType" required :append-icon="newPwdIcon" @click:append="showNewPWD"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field v-model="CheckPwd" :rules="[(v) => !!v || '必填項目', (v) => (v || '') === setPwdModel.Password || '密碼不一致']"
                                    label="確認新密碼" type="password" required></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="4" md="4">
                                <v-btn block class="mt-3 mb-1" type="button" @click="cancelReSetPwd">取消</v-btn>
                            </v-col>
                            <v-col cols="4" md="4">
                                <v-btn block color="primary" class="mt-3 mb-1" type="submit">送出</v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                    </v-stepper-content>
                </v-stepper-items>
                </v-stepper>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style scope>
/* 預設樣式：PC 端樣式 */
.my-div {
    width: 50%;           /* 設置為 PC 預設寬度 */
    padding: 20px;
    margin: auto;
}

/* 手機端樣式 */
@media (max-width: 768px) {
    .my-div {
        width: 100%;        /* 手機螢幕寬度較小，因此設置較大的寬度以填滿 */
        padding: 15px;     /* 調整 padding 適應手機端 */
    }
}
</style>

<script>
import md5 from 'js-md5';
import Guide from '../components/Guide.vue'

export default {
  name: 'Confirm',
  components: {
    Guide,
  },
  data: () => ({
    valid: false,
    model: {
        Account: null,
        Password: null
    },
    eyeIcon: 'mdi-eye-off',
    passwordType: 'password',
    newPwdIcon: 'mdi-eye-off',
    newPwdType: 'password',
    setPwdDialog: false,
    setPwdStep: 1,
    verifyAccount: false,
    verifyNewPwd: false,
    setPwdModel: {
        Account: null,
        Password: null,
        VerifyCode: null
    },
    CheckPwd: null,
    taiwanMobileRegex: /^09\d{8}$/,
    otp: '',
  }),
  created() {
  },
  methods: {
    submit() {
      if (this.valid) {
        const requset = {
            Account : this.model.Account,
            Password : md5(this.model.Password)
        }
        this.dbio('/Auth/Login', requset, 'post').then((response) => {
            if(response.Success) {
                this.$store.dispatch("loginstatus/setLoginStatus", {status: true, token: response.AuthToken, changePWD: response.ForceChangePWD});
                this.$router.push({ name: 'Home' });
            } else {
                this.msg(response.ReturnMsg, 3000);
            }
        });
      }
    },
    showPWD() {
        if (this.passwordType == 'password') {
            this.passwordType = 'text'
            this.eyeIcon = 'mdi-eye-outline';
        } else {
            this.passwordType = 'password'
            this.eyeIcon = 'mdi-eye-off';
        }
    },
    showNewPWD() {
        if (this.newPwdType == 'password') {
            this.newPwdType = 'text'
            this.newPwdIcon = 'mdi-eye-outline';
        } else {
            this.newPwdType = 'password'
            this.newPwdIcon = 'mdi-eye-off';
        }
    },
    onOTPFinish(rsp) {
        const requset = {
            Account: this.setPwdModel.Account,
            VerifyCode: rsp,
            ReSetProcess: 2
        }
        this.dbio('/Auth/ResetPWD', requset, 'post').then((response) => {
            if(response.Success) {
                this.setPwdStep += 1;
                this.setPwdModel.VerifyCode = rsp;
            } else {
                this.msg(response.ReturnMsg, 10000);
                this.otp = '';
                this.$refs.otpInput.focus();
            }
        });
    },
    submitReSetPwd(ProcessStep) {
        if (ProcessStep === 1) {
            this.$refs.verifyAccount.validate();
            if (this.verifyAccount) {
                const requset = {
                    Account : this.setPwdModel.Account,
                    ReSetProcess: 1
                }
                this.dbio('/Auth/ResetPWD', requset, 'post').then((response) => {
                    if(response.Success) {
                        if(response.ReturnMsg) this.msg(response.ReturnMsg, 5000, 'primary');
                        this.setPwdStep += 1;
                    } else {
                        this.msg(response.ReturnMsg, 5000);
                    }
                });
            }
        } else {
            this.$refs.verifyNewPwd.validate();
            if (this.verifyNewPwd) {
                const requset = {
                    Account: this.setPwdModel.Account,
                    Password: this.setPwdModel.Password,
                    VerifyCode: this.setPwdModel.VerifyCode,
                    ReSetProcess: 3
                }
                this.dbio('/Auth/ResetPWD', requset, 'post').then((response) => {
                    if(response.Success) {
                        this.cancelReSetPwd();
                        this.msg("更改成功，請使用新密碼登入", 5000, 'primary');
                    } else {
                        this.msg(response.ReturnMsg, 5000);
                    }
                });
            }
        }
    },
    cancelReSetPwd() {
      this.$refs.verifyAccount.reset();
      this.setPwdModel =  {
            Account: null,
            Password: null,
            VerifyCode: null
        };
      this.setPwdDialog = false;
      this.otp = '';
      this.setPwdStep = 1;
      this.CheckPwd = '';
    },
    backStep() {
      this.otp = '';
      this.setPwdStep = 1;
    },
    goERC() {
        //window.location.href = process.env.VUE_APP_ERCURL;
        window.open(process.env.VUE_APP_ERCURL, '_blank').focus();
    },
    showGuide(){
    // 通過 ref 控制 Guide 組件的 mainDialog 顯示
      this.$refs.guide.mainDialog = true;
    }
  }
};
</script>